/* Sale countdown of the article page. Counts down to a fixed end time (Norwegian time) set in the theme editor. */
(function () {
  if (window.__advCountdown) return;
  window.__advCountdown = true;

  var ZONE = 'Europe/Oslo';
  var design = !!(window.Shopify && window.Shopify.designMode);
  var fmt = null;
  try {
    fmt = new Intl.DateTimeFormat('en-US', { timeZone: ZONE, hourCycle: 'h23', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' });
  } catch (e) {}

  // How many minutes Norway is ahead of UTC at the moment t (milliseconds).
  function offsetAt(t) {
    var p = {};
    fmt.formatToParts(new Date(t)).forEach(function (x) { p[x.type] = parseInt(x.value, 10); });
    return (Date.UTC(p.year, p.month - 1, p.day, p.hour % 24, p.minute, p.second) - Math.floor(t / 1000) * 1000) / 60000;
  }

  // "2026-10-31 18:00" (Norwegian time) -> milliseconds, or NaN when the text is not a date.
  function parse(text) {
    var m = /^\s*(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T]+(\d{1,2}):(\d{2}))?\s*$/.exec(text || '');
    if (!m || !fmt) return NaN;
    var hasTime = m[4] !== undefined;
    var guess = Date.UTC(+m[1], +m[2] - 1, +m[3], hasTime ? +m[4] : 23, hasTime ? +m[5] : 59, hasTime ? 0 : 59);
    var t = guess - offsetAt(guess) * 60000;
    var off2 = offsetAt(t);
    return guess - off2 * 60000;
  }

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function show(el, on) {
    if (el) el.hidden = !on;
  }

  function update(el) {
    var timer = el.querySelector('[data-adv-timer]');
    var msg = el.querySelector('[data-adv-msg]');
    var text = '';
    if (!timer) {
      // No end date set: only the theme editor shows a hint (written by the template).
      if (msg && msg.textContent) msg.hidden = false;
      return;
    }
    var end = parse(el.getAttribute('data-end'));
    if (isNaN(end)) {
      show(timer, false);
      if (design) text = 'Check the end date. Use the format 2026-10-31 18:00';
    } else {
      var left = Math.floor((end - Date.now()) / 1000);
      if (left > 0) {
        setUnits(timer, left);
        show(timer, true);
      } else {
        var hideAll = el.getAttribute('data-ended') !== 'timer';
        show(timer, design);
        if (design) {
          setUnits(timer, 0);
          text = hideAll ? 'The time is up. Customers do not see this banner.' : 'The time is up. Customers do not see the timer.';
        } else if (hideAll) {
          el.style.display = 'none';
        }
      }
    }
    if (msg) {
      msg.textContent = text;
      msg.hidden = !text;
    }
  }

  function setUnits(timer, left) {
    var d = Math.floor(left / 86400);
    var vals = { d: d, h: Math.floor((left % 86400) / 3600), m: Math.floor((left % 3600) / 60), s: left % 60 };
    for (var k in vals) {
      var box = timer.querySelector('[data-u="' + k + '"]');
      if (!box) continue;
      box.querySelector('b').textContent = pad(vals[k]);
      if (k === 'd') box.hidden = d < 1;
    }
  }

  function tick() {
    var list = document.querySelectorAll('[data-adv-count]');
    for (var i = 0; i < list.length; i++) update(list[i]);
  }

  tick();
  setInterval(tick, 1000);
})();